// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var H3 = function H3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h3-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 3.582c0-.426.344-.77.77-.77h3.585a.769.769 0 1 1 0 1.54H3.328V8.96h7.68V4.35H9.984a.769.769 0 1 1 0-1.538h3.582a.768.768 0 1 1 0 1.539h-1.023v11.261h1.023a.768.768 0 1 1 0 1.54H9.984a.768.768 0 1 1 0-1.54h1.024v-5.12h-7.68v5.12h1.024a.768.768 0 1 1 0 1.54H.77a.774.774 0 0 1-.77-.774c0-.426.344-.77.77-.77h1.023V4.348H.77A.765.765 0 0 1 0 3.582m15.352 7c0-.281.207-.504.464-.504h3.489c.191 0 .363.129.433.32a.54.54 0 0 1-.117.555l-1.906 1.899h.316c1.09 0 1.977.96 1.977 2.144s-.883 2.145-1.977 2.145h-1.148c-.617 0-1.18-.38-1.453-.977l-.028-.059c-.113-.25-.023-.55.207-.675s.508-.024.625.226l.028.059a.69.69 0 0 0 .625.418h1.14c.578 0 1.047-.508 1.047-1.137s-.469-1.137-1.047-1.137h-1.511a.47.47 0 0 1-.434-.32.54.54 0 0 1 .117-.555l1.906-1.898h-2.289c-.257 0-.464-.227-.464-.504"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "h3-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
